import { notificationStrategyRegistry } from '@/infrastructure/notifications/realtime/registry';
import { i18nRealtimeStrategy } from './i18n-realtime-strategy';

notificationStrategyRegistry.register(i18nRealtimeStrategy);
